import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => ({
  App: {
    minHeight: '100vh',
    backgroundColor: '#fff',
    fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: '#000000',
  },
}))
